import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './common/i18n/i18n';

const hash = window.location.hash || "";
const looksLikeDuploCallback = hash.includes("id_token=") || hash.includes("security_token=");
const phonebookAuthInProgress = sessionStorage.getItem("pb_auth_in_progress") === "true";
const phonebookReturnUrl = sessionStorage.getItem("pb_viewmore_returnUrl") || "/";
// IMPORTANT: do not pre-redirect Duplo callback from bootstrap.
// If we redirect here, callback hash/token can be consumed before
// authenticator.authenticateUser() handles it.

// Duplo is returning callback tokens on '/#id_token=...'.
// Route that callback back to auth-gate while preserving hash tokens.
if (
  looksLikeDuploCallback &&
  phonebookAuthInProgress &&
  window.location.pathname === "/"
) {
  const safeReturnUrl = phonebookReturnUrl.startsWith("/") ? phonebookReturnUrl : "/";
  const target = `/phonebook/view-more?returnUrl=${encodeURIComponent(safeReturnUrl)}${hash}`;
  window.location.replace(target);
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
